function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMailIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 63 51",
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M57.587 0h-50.4C3.722 0 .918 2.869.918 6.375l-.031 38.25c0 3.506 2.835 6.375 6.3 6.375h50.4c3.465 0 6.3-2.869 6.3-6.375V6.375c0-3.506-2.835-6.375-6.3-6.375Zm0 44.625h-50.4V12.75l25.2 15.938 25.2-15.938v31.875Zm-25.2-22.312L7.187 6.375h50.4l-25.2 15.938Z",
  style: {
    fill: "currentColor"
  },
  transform: "translate(-.886)"
}));
export default SvgMailIcon;